import { MediaQueries, PopupFrame } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledFormWrapper = styled.div`
  padding: 16px;
`
export const StyledNote = styled.div`
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 20px;
`

export const StyledPopupFrame = styled(PopupFrame)`
  position: relative;
  z-index: 600;
  [data-type='confirm'] {
    height: auto;
    overflow-y: auto;
    .popup-content {
      .header {
        padding-left: 16px;
      }
    }

    ${MediaQueries.mbDown} {
      width: 100vw;
      height: 100%;
      transition: all 0.3s ease-in-out 0s;

      &[data-open='true'] {
        z-index: 500;
      }
    }

    ${MediaQueries.mbUp} {
      max-height: calc(100% - 42px);
    }
  }
`
